<div class="space"></div>

<div class="lightgray">
	<section id="slider">
		<div class="slide">
			<div class="somos">
				<div class="wrapper">
					<div class="info anime-element fadeleft-animation">
						<div class="gtitle">
							<h2>AppSheet</h2>
						</div>
						<div class="fluid">
							<div class="piece">
								<h4>
                                    <span>{{ 'cloud.title864' | translate }}</span> {{ 'cloud.title865' | translate }}
                                    <span>{{ 'cloud.title866' | translate }}</span>
                                </h4>
								<ul>
									<li>{{ 'cloud.title867' | translate }}</li>
									<li>{{ 'cloud.title868' | translate }}</li>
									<li>{{ 'cloud.title869' | translate }}</li>
									<li>{{ 'cloud.title870' | translate }}</li>
								</ul>
                                 <div class="sim-button button14" (click)='scroll(ibox)'>
                                    <span>{{ 'cloud.title158' | translate }}</span>
                                    <img class="arrow22" src="../../../../assets/img/arrow.svg" alt="">
                                </div>
							</div>
						</div>
					</div>
					<div class="foto">
						<img src="../../../../assets/img/customer/component_appshet_banner.jpg" alt="">
					</div>
				</div>
			</div>
		</div>
	</section>
</div>


<div class="content-area">
	<div class="wrap">
		<section id="copy">
            <div class="center">
                <img class="bcustomer" src="../../../../assets/img/appsheet/appsheet-logo.png" alt="">
            </div>
            <p class="select">
            {{ 'cloud.title871' | translate }}</p>
		</section>
    </div>
</div>



<img class="wave" src="../../../../../assets/img/bg-wave.svg" alt="">
<div class="content-area">

    <div class="wrap">

		<section id="beneficios">
            <div class="titulo">
                <h2>{{ 'cloud.title872' | translate }}</h2>
            </div>
			<div class="flex6">
				<div class="element6">
					<div class="fluid">
						<div class="barra piece">
							<img class="number" src="../../../../assets/img/customer/pencil.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
							     <p>{{ 'cloud.title873' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../assets/img/customer/teaching.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
                                <p>{{ 'cloud.title874' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../assets/img/customer/solution.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
							     <p>{{ 'cloud.title875' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../assets/img/customer/communication.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
							     <p>{{ 'cloud.title876' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
			</div>

		</section>


	</div>
</div>


<div class="fondo21">
    
    <div class="titulo">
        <h2>{{ 'cloud.title919' | translate }}</h2>
    </div>
    <div class="colors colors-change">
        <div [ngClass]="{'active' : solution === 'apoyo'}" class="color apoyo">
            <div class="raw color1"></div>
        </div>
        <div [ngClass]="{'active' : solution === 'tooglebox'}" class="color tooglebox">
            <div class="raw color2"></div>
        </div>
        <div [ngClass]="{'active' : solution === 'transfer'}" class="color transfer">
            <div class="raw color3"></div>
        </div>
        <div [ngClass]="{'active' : solution === 'projects'}" class="color projects">
            <div class="raw color4"></div>
        </div>
    </div>



    <div class="content-area">
        <div class="wrap">

            <article class="services">
                <nav class="{{solution}}">

                    <button [ngClass]="{'active': solution === 'transfer'}" (click)="changeSolution('transfer', '')">
                        <p style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title877' | translate }}</p>
                    </button>

                    <button [ngClass]="{'active': solution === 'apoyo'}" (click)="changeSolution('apoyo', '')">
                        <p style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title878' | translate }}</p>
                    </button>

                    <button [ngClass]="{'active': solution === 'projects'}" (click)="changeSolution('projects', '')">
                        <p style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title879' | translate }}</p>
                    </button>

                    <button [ngClass]="{'active': solution === 'tooglebox'}" (click)="changeSolution('tooglebox', '')">
                        <p style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title880' | translate }}</p>
                    </button>

                </nav>






                <div class="wrapper soluciones-wrap">


                    <div [ngClass]="{'active' : solution === 'transfer'}" class="solucion transfer">
                        <div class="card-wrapper">
                            <div class="piece21">
                                <ul>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title890' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title891' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title892' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title893' | translate }}</li>
                                </ul>
                            </div>
                            <div class="piece21">
                            </div>
                        </div>
                    </div>


                    <div [ngClass]="{'active' : solution === 'apoyo'}" class="solucion apoyo">
                        <div class="card-wrapper">
                            <div class="piece21">
                                <!--<img class="elearn" src="../../../../assets/img/customer/AFLogoesclearning-01.png" alt="">-->
                                <ul>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title894' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title895' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title896' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title897' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title898' | translate }}</li>
                                </ul>
                            </div>
                            <div class="piece21"></div>
                        </div>
                    </div>

                    <div [ngClass]="{'active' : solution === 'projects'}" class="solucion projects">
                        <div class="card-wrapper">
                            <div class="piece21">
                                <!--<img class="elearn" src="../../../../assets/img/customer/AFLogoesclearning-01.png" alt="">-->
                                <ul>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title899' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title900' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title901' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title902' | translate }}</li>
                                </ul>
                            </div>
                            <div class="piece21"></div>
                        </div>
                    </div>

                    <div [ngClass]="{'active' : solution === 'tooglebox'}" class="solucion tooglebox">
                        <div class="card-wrapper">

                        <div class="piece21">
                                <!--<img class="tooglebox" src="../../../../assets/img/customer/tooglebox.svg" alt="">
                                <h4>{{ 'cloud.title204' | translate }}<br><br>
                                {{ 'cloud.title205' | translate }}
                                </h4>-->
                                <ul>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title903' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title904' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title905' | translate }}</li>
                                    <li style="font-size: 25px !important; line-height: 30px;">{{ 'cloud.title906' | translate }}</li>
                                </ul>
                            </div>
                            <div class="piece21">
                            </div>
                        </div>
                    </div>

                </div>
            </article>

        </div>
    </div>



</div>

<div class="space"></div>

<div class="content-area">
    <div class="wrap">

        <section class="vc_section readapt">

            <div class="flex6 website">
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="icloud-b" src="../../../../assets/img/appsheet/acroos_dev.png" alt="cloud">
                        <img class="icloud" src="../../../../assets/img/appsheet/acroos_dev.png" alt="cloud">-->
                        <i class="material-icons icloud">devices</i> 
                        <div class="table">

                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title907' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="icloud-b" src="../../../../assets/img/appsheet/capture_images.png" alt="cloud">
                        <img class="icloud" src="../../../../assets/img/appsheet/capture_images.png" alt="">-->
                        <i class="material-icons icloud">photo_camera</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title908' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="users-b" src="../../../../assets/img/appsheet/wifi.png" alt="">
                        <img class="users" src="../../../../assets/img/appsheet/wifi.png" alt="">-->
                        <i class="material-icons icloud">wifi_off</i>
                        <div class="table">
                           
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title909' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="admin-b" src="../../../../assets/img/customer/admin-icon-b.svg" alt="">
                        <img class="admin" src="../../../../assets/img/customer/admin-icon.svg" alt="">-->
                        <i class="material-icons icloud">notifications</i>

                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title910' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="icloud-b" src="../../../../assets/img/customer/formacion-icon-b.svg" alt="cloud">
                        <img class="icloud" src="../../../../assets/img/customer/formacion-icon.svg" alt="">-->
                        <i class="material-icons icloud">edit</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title911' | translate }} </h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="icloud-b" src="../../../../assets/img/customer/comunication-icon-b.svg" alt="cloud">
                        <img class="icloud" src="../../../../assets/img/customer/comunication-icon.svg" alt="">-->
                        <i class="material-icons icloud">bar_chart</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title912' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="icloud-b" src="../../../../assets/img/customer/support-b.svg" alt="cloud">
                        <img class="icloud" src="../../../../assets/img/customer/support.svg" alt="">-->
                        <i class="material-icons icloud">schema</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title913' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="atencion-b" src="../../../../assets/img/customer/attention-icon-b.svg" alt="cloud">
                        <img class="atencion" src="../../../../assets/img/customer/attention-icon.svg" alt="">-->
                        <i class="material-icons icloud">insert_chart</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title914' | translate }}</h3>
                    </div>
                </div>

                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="atencion-b" src="../../../../assets/img/customer/attention-icon-b.svg" alt="cloud">
                        <img class="atencion" src="../../../../assets/img/customer/attention-icon.svg" alt="">-->
                        <i class="material-icons icloud">qr_code</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title915' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="atencion-b" src="../../../../assets/img/customer/attention-icon-b.svg" alt="cloud">
                        <img class="atencion" src="../../../../assets/img/customer/attention-icon.svg" alt="">-->
                        <i class="material-icons icloud">pin_drop</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title916' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="atencion-b" src="../../../../assets/img/customer/attention-icon-b.svg" alt="cloud">
                        <img class="atencion" src="../../../../assets/img/customer/attention-icon.svg" alt="">-->
                        <i class="material-icons icloud">forward_to_inbox</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title917' | translate }}</h3>
                    </div>
                </div>
                <div class="elementb box">
                    <div class="high" style="align-items: center;">
                        <!--<img class="atencion-b" src="../../../../assets/img/customer/attention-icon-b.svg" alt="cloud">
                        <img class="atencion" src="../../../../assets/img/customer/attention-icon.svg" alt="">-->
                        <i class="material-icons icloud">integration_instructions</i>
                        <div class="table">
                        </div>
                    </div>
                    <div class="low">
                        <h3>{{ 'cloud.title918' | translate }}</h3>
                    </div>
                </div>

            </div>
        </section>

        <section class="intereses">
            <div class="wrapper">
                <h3>{{ 'cloud.title225' | translate }}</h3>
                <div class="card-wrapper">
                    <div class="card" routerLink="/workspace">
                        <img class="img-iconb" src="../../../../../assets/img/Google_Workspace_Logo.svg" alt="Cloud">
                        <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
                    </div>
<!--                     <div class="card">

                            <div class="ibox">
                                <img class="gcplat" src="../../../../assets/img/gcplat.svg" alt="">
                            </div>
                            <div class="ibox">
                                <p>GCP Onboarding</p>
                            </div>

                        <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
                    </div> -->

                </div>
            </div>
        </section>

    </div>
</div>


<div style="margin-bottom: -40px;">
    <div #ibox>
        <app-form></app-form>
    </div>
</div>







